import React, { useEffect, useRef, useState } from 'react';
import { PeriodicReportingType } from '../PeriodicReporting';
import { Col, Form, Row } from 'react-bootstrap';
import { InputNumber } from 'primereact/inputnumber';
import { useLocation } from 'react-router-dom-v5-compat';
import { updateStatementStatusByProjectIdAndStatementId } from 'lib/api_ts/periodicReportingApi';
import { debounce } from '@mui/material';
import { isValid } from 'date-fns';
import { getProject } from '@lib/api_ts/projectApi';
import StatusBar from '@components/StatusBar';
import { useQuery } from '@tanstack/react-query';
// import { formatToDecimals } from "lib/helpers/formatting";

interface PeriodicReportingStatusProps {
	data: PeriodicReportingType;
	isBeneficiary: boolean;
	isEnabledToView: boolean;
	isWP?: boolean;
}

const PeriodicReportingStatus: React.FC<PeriodicReportingStatusProps> = ({ data, isBeneficiary, isEnabledToView }) => {
	const { pathname } = useLocation();
	const projectId = pathname.split('/')[2];
	const [sbShow, setSbShow] = useState(<></>);

	const { data: projectData } = useQuery({
		queryKey: ['project', projectId],
		queryFn: () => getProject(projectId),
		enabled: projectId !== undefined,
		refetchOnMount: false,
	});

	const [status, setStatus] = useState({
		sent: {
			checked: !!data.sent,
			date: data.sentDate || '',
			amount: data.amount,
		},
		approved: {
			checked: !!data.approved,
			date: data.approvedDate || '',
			amount: data.approvedAmount,
		},
		cashedIn: {
			checked: !!data.cashedIn,
			date: data.cashedInDate || '',
			amount: data.cashedInAmount,
		},
	});

	const rows = [
		{
			name: 'sent',
			label: 'Contributo Richiesto €',
			amount: status.sent.amount,
			checkboxLabel: 'inviato',
			checked: status.sent.checked,
			date: status.sent.date,
		},
		{
			name: 'approved',
			label: 'Contributo Approvato €',
			amount: status.approved.amount,
			checkboxLabel: 'approvato',
			checked: status.approved.checked,
			date: status.approved.date,
		},
		{
			name: 'cashedIn',
			label: 'Contributo Incassato €',
			amount: status.cashedIn.amount,
			checkboxLabel: 'incassato',
			checked: status.cashedIn.checked,
			date: status.cashedIn.date,
		},
	];

	const localLang = `${localStorage.getItem('userLanguage').toLowerCase()}-${localStorage.getItem('userLanguage')}`;

	const isModifiedRef = useRef(false);
	useEffect(() => {
		if (!isModifiedRef.current) return;
		if (new Date(status.sent.date).getFullYear() < 2000 || new Date(status.approved.date).getFullYear() < 2000) return;
		if (
			new Date(status.sent.date) < new Date(projectData?.forecastStartDate) ||
			new Date(status.approved.date) < new Date(projectData?.forecastStartDate) ||
			new Date(status.cashedIn.date) < new Date(projectData?.forecastStartDate)
		) {
			setSbShow(
				<StatusBar status="error" message={'La data inserita non può essere precedente alla data di avvio del progetto'} timeout={false}>
					<></>
				</StatusBar>,
			);
			return;
		}
		setSbShow(<></>);
		try {
			(async () => {
				await updateStatementStatusByProjectIdAndStatementId(projectId, data.id, {
					statementTypeCode: 'PR',
					sent: status.sent.checked,
					amount: status.sent.amount,
					sentDate: status.sent.date,
					approved: status.approved.checked,
					approvedAmount: status.approved.amount,
					approvedDate: status.approved.date,
					cashedIn: status.cashedIn.checked,
					cashedInAmount: status.cashedIn.amount,
					cashedInDate: status.cashedIn.date,
				});
			})();
		} catch (error) {
			console.error('Error updating statement', error);
		}
	}, [status, data.id, projectId, projectData?.forecastStartDate]);

	const debouncedSetAmount = useRef(
		debounce((name: 'sent' | 'approved', amount: number) => {
			setStatus((prevState) => ({
				...prevState,
				[name]: {
					...prevState[name],
					amount,
				},
			}));
		}, 500),
	);

	return (
		<Form className="p-4">
			{rows.map((row) => (
				<Row key={row.name} className="align-items-end mb-5">
					<Form.Group as={Col} md={3}>
						<Form.Label className="mb-3">{row.label}</Form.Label>
						{/* <Form.Control
              value={status[row.name].amount}
              onChange={(event) => {
                setStatus((prevState) => ({
                  ...prevState,
                  [row.name]: {
                    ...prevState[row.name],
                    amount: Number(event.target.value),
                  },
                }));
              }}
            /> */}
						{/* {row.name === "sent" ? (
              <div style={{ height: "38px", textAlign: "right" }}>
                <div
                  style={{
                    border: "1px solid #b3b3b3",
                    borderRadius: "8px",
                    color: "#1c2743",
                    padding: "6px 12px",
                  }}
                >
                  {formatToDecimals(status[row.name].amount || 0)}
                </div>
              </div>
            ) : null} */}
						{/* {row.name === "approved" ? ( */}
						<InputNumber
							value={status[row.name].amount}
							onChange={(event) => {
								if (!isModifiedRef.current) isModifiedRef.current = true;
								debouncedSetAmount.current(row.name as 'sent' | 'approved', event.value || 0);

								// setStatus((prevState) => ({
								//   ...prevState,
								//   [row.name]: {
								//     ...prevState[row.name],
								//     amount: event.value || 0,
								//   },
								// }));
							}}
							mode="decimal"
							minFractionDigits={2}
							maxFractionDigits={2}
							min={0}
							step={1}
							locale={localLang}
							disabled={isBeneficiary && !isEnabledToView}
						/>
						{/* ) : null} */}
						{/* <Form.Text as="p">{row.amount}</Form.Text> */}
						{/* <InputNumber
              value={status[row.name].amount}
              onChange={(event) => {
                if (!isModifiedRef.current) isModifiedRef.current = true;
                debouncedSetAmount.current(
                  row.name as "sent" | "approved",
                  event.value || 0
                );

                // setStatus((prevState) => ({
                //   ...prevState,
                //   [row.name]: {
                //     ...prevState[row.name],
                //     amount: event.value || 0,
                //   },
                // }));
              }}
              mode="decimal"
              minFractionDigits={2}
              maxFractionDigits={2}
              min={0}
              step={1}
              locale={localLang}
            /> */}
					</Form.Group>
					<Form.Group as={Col} md={1} className="d-flex align-items-center gap-2 mb-2 me-4">
						<Form.Label className="mb-0 fw-bold">{row.checkboxLabel}</Form.Label>
						<Form.Check
							type="switch"
							checked={row.checked}
							onChange={(event) => {
								if (!isModifiedRef.current) isModifiedRef.current = true;
								setStatus((prevState) => ({
									...prevState,
									[row.name]: {
										...prevState[row.name],
										checked: event.target.checked,
										date: event.target.checked ? prevState[row.name].date : '',
									},
								}));
							}}
							disabled={isBeneficiary && !isEnabledToView}
						/>
					</Form.Group>
					<Form.Group as={Col} md={3}>
						<Form.Label>In data</Form.Label>
						<Form.Control
							type="date"
							disabled={!status[row.name].checked || (isBeneficiary && !isEnabledToView)}
							value={status[row.name].date}
							min={projectData?.forecastStartDate.split('T')[0] ?? ''}
							onChange={(event) => {
								if (!isModifiedRef.current) isModifiedRef.current = true;
								const selectedDate = new Date(event.target.value);
								if (!isValid(selectedDate)) return;
								setStatus((prevState) => ({
									...prevState,
									[row.name]: {
										...prevState[row.name],
										date: event.target.value,
									},
								}));
							}}
						/>
					</Form.Group>
				</Row>
			))}
			{sbShow}
		</Form>
	);
};

export default PeriodicReportingStatus;
